import React from 'react'
import "./OrderBuySell.scss"
import { useSelector } from 'react-redux'
import { toFix } from '../../../../helpers/commonHelper';

const OrderBuySell = ({ className, orderclass, clrclass, headclass, head, orderBook, side }) => {
    const selectedPair = useSelector(state => state.ats.selectedPair);
    return (
        <>
            <div className={`OrderBuysell ${className}`}>
                {head && (
                    <div className={`OrderBuysell_Row BuysellThead ${headclass}`}>
                        <div className='OrderBuysell_Col'>
                            <h6 className='text-start'>Price <span className='d-block'>{selectedPair ? `(${selectedPair?.baseCurrency.toUpperCase()})` : ''}</span></h6>
                            {/* <h6 className='text-start'>Price <span className='d-block'>{selectedPair ? `(${selectedPair?.name?.split('/')[1].toUpperCase()})` : ''}</span></h6> */}
                        </div>
                        <div className='OrderBuysell_Col'>
                            <h6>Size <span className='d-block'>{selectedPair ? `(${selectedPair?.otherCurrency.toUpperCase()})` : ''}</span></h6>
                            {/* <h6>Size <span className='d-block'>{selectedPair ? `(${selectedPair?.name?.split('/')[0].toUpperCase()})` : ''}</span></h6> */}
                        </div>
                        <div className='OrderBuysell_Col'>
                            <h6>Total</h6>
                        </div>
                    </div>
                )}
                <div className={`BuysellTdata ${orderclass} ${side === 0 ? 'orderBookBuy' : 'orderBookSell'}`}>
                    {orderBook.map((item, i) => {
                        return (
                            <div key={i} className="OrderBuysell_Row">
                                <div className='OrderBuysell_Col'>
                                    <p className={`text-start ${clrclass}`}>{toFix(item?.price, selectedPair?.price_decimal)}</p>
                                </div>
                                <div className='OrderBuysell_Col'>
                                    <p>{toFix(item?.quantity, selectedPair?.quantity_decimal)}</p>
                                </div>
                                <div className='OrderBuysell_Col'>
                                    <p>{toFix(item?.total, selectedPair?.price_decimal + selectedPair?.quantity_decimal)}</p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </>
    )
}

export default OrderBuySell
